'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { DocsLinks } from '@/components/how-it-works/docs-links';
import { Coins01Icon, IdeaIcon, MessageMultiple01Icon } from '@/components/ui/icon/glyphs';
import { InfoModal } from '@/components/ui/info-modal';
interface ThesesHowItWorksModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Explains what a thesis is, opened from the info button on the portfolio
 * Theses panel header. A thesis is a short (280-character) take a user attaches
 * to a real buy/sell — it joins the parent market's Debate tab, where others
 * can upvote, reply, and push back.
 */
export function ThesesHowItWorksModal(t0) {
  const $ = _c(49);
  const {
    open,
    onOpenChange
  } = t0;
  const t = useTranslations("theses_how_it_works");
  let t1;
  if ($[0] !== t) {
    t1 = t("title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("description");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("got_it");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onOpenChange) {
    t4 = () => onOpenChange(false);
    $[6] = onOpenChange;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <InfoModal.Footer cta={t3} onClose={t4} />;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("share_title");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("share_description");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <InfoModal.IconItem icon={IdeaIcon} title={t6} description={t7} />;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("conviction_title");
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("conviction_description");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t9) {
    t11 = <InfoModal.IconItem icon={Coins01Icon} title={t9} description={t10} />;
    $[22] = t10;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t) {
    t12 = t("debate_title");
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t) {
    t13 = t("debate_description");
    $[27] = t;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t12 || $[30] !== t13) {
    t14 = <InfoModal.IconItem icon={MessageMultiple01Icon} title={t12} description={t13} />;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t11 || $[33] !== t14 || $[34] !== t8) {
    t15 = <InfoModal.IconList>{t8}{t11}{t14}</InfoModal.IconList>;
    $[32] = t11;
    $[33] = t14;
    $[34] = t8;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t) {
    t16 = t("info");
    $[36] = t;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t16) {
    t17 = <InfoModal.Callout>{t16}</InfoModal.Callout>;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <DocsLinks docsPath="/guides/theses" />;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== onOpenChange || $[42] !== open || $[43] !== t1 || $[44] !== t15 || $[45] !== t17 || $[46] !== t2 || $[47] !== t5) {
    t19 = <InfoModal open={open} onOpenChange={onOpenChange} size="lg" title={t1} description={t2} footer={t5}>{t15}{t17}{t18}</InfoModal>;
    $[41] = onOpenChange;
    $[42] = open;
    $[43] = t1;
    $[44] = t15;
    $[45] = t17;
    $[46] = t2;
    $[47] = t5;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  return t19;
}